"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeginYourJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222946" id="initiate-bulk-transaction" className="bg-primary text-primary-foreground relative py-20 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground/5 via-transparent to-transparent pointer-events-none" />

      {}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-foreground/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="order-2 lg:order-1 relative rounded-none overflow-hidden border-4 border-foreground shadow-xl group">
            <div className="absolute inset-0 bg-gradient-to-tr from-foreground/20 via-transparent to-transparent z-10 pointer-events-none" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/professional_learning_platform.png" alt="Arem Metals global bulk scrap logistics" className="w-full h-full object-cover aspect-[4/3] lg:aspect-square transition-transform duration-700 group-hover:scale-105" />
            {}
            <div className="absolute bottom-6 left-6 right-6 z-20 p-6 rounded-none bg-primary/90 backdrop-blur-md border-2 border-foreground shadow-lg">
              
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-none bg-foreground text-primary text-sm font-bold mb-6 w-fit border border-foreground uppercase tracking-wider">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              Direct Export Operations
            </div>
            
            <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-6 text-foreground leading-[1.05] uppercase">
              READY TO MOVE VOLUME?
            </h2>
            
            <p className="font-mono text-lg sm:text-xl text-foreground/90 mb-10 max-w-xl leading-relaxed">
              Arem Metals specializes in high-volume scrap metal trading and global logistics. From HMS 1/2 to shredded materials, we coordinate bulk exports from North American yards to international steel mills.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 rounded-none text-base font-bold shadow-xl bg-foreground text-primary hover:bg-foreground/90 border-2 border-foreground">
                <Link to="#">
                  Sell Bulk Scrap
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 rounded-none text-base font-bold border-2 border-foreground text-foreground hover:bg-foreground/10 bg-transparent">
                <Link to="#">
                  Buy Bulk Scrap
                </Link>
              </Button>
            </div>
            
            <div className="mt-8 flex items-center gap-6 text-sm font-bold font-mono text-foreground uppercase tracking-tight">
              <div className="flex items-center gap-2">
                <svg className="size-5 text-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
                Global CFR Shipping
              </div>
              <div className="flex items-center gap-2">
                <svg className="size-5 text-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
                Direct Yard Sourcing
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}